import Vue, { ComponentOptions } from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import CommonService from '../services/common-service'


@Component({
    template: require('./contact-us.html'),
})
export default class ContactUs extends Vue {
    emailRE: RegExp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    validationInitiated: boolean = false;

    contactUsData: any = {
        firstName: "",
        lastName: "",
        email: "",
        company: "",
        message: ""
    };

    validation() {
        return {
            firstName: !!this.contactUsData.firstName.trim(),
            lastName: !!this.contactUsData.lastName.trim(),
            email: this.emailRE.test(this.contactUsData.email),
            company: !!this.contactUsData.company.trim(),
            message: !!this.contactUsData.message.trim()
        }
    }

    isValid() {
        if (this.validationInitiated) {
            var validation = this.validation();

            let result = Object.keys(validation).every(function (key) {
                return validation[key]
            });

            return result;
        } else {
            return true;
        }
    }

    validate() {
        return this.isValid();
    }

    complete() {
        this.validationInitiated = true;

        if (this.isValid()) {
            let userData = this.contactUsData;

            CommonService.sendContactUsData(userData).then((res: any) => { console.log(res) });

            this.$parent.$emit('close');
        }
    }
}


// WEBPACK FOOTER //
// ./static-content/public/javascripts/components/contact-us.ts